<template>
  <div class="page">
    <!-- Hero -->
    <div class="container">
      <div v-if="showSample" class="pdfModal">
        <div class="pdfBox">
      
          <div class="pdfScrollArea">
            <img
              v-for="page in samplePages"
              :key="page"
              :src="`/sample_claim_${page}.jpg`"
              class="sampleImg"
            />
          </div>
      
          <div class="pdfFooter">
            <button class="closeFullBtn" @click="showSample = false">
              닫기
            </button>
          </div>
      
        </div>
      </div>
      <div class="heroInner">
        
        <!-- Main Card -->
          <!--<div class="panelHeader">
            <div>
              <div class="panelTitle">보험금 청구서 자동 생성</div>
              <div class="panelDesc">
                보험사별로 PDF 템플릿/좌표가 다르므로 insurer_code 기준으로 분기합니다.
              </div>
            </div>
          </div> -->
          <div class="grid">
            <!-- <h1 class="title">CLAIM it.</h1> -->
            <div class="card full">
              <div class="flowRow">
                <div class="flowText">
                  보험금 청구서 PDF를 자동 생성합니다.<br />
                  보험사 선택 → 입력 → 서명 → PDF 생성 한 번에.
                </div>
            
                <button class="btnSample" @click="showSample = true">
                  📄 샘플 PDF 보기
                </button>
              </div>
            </div>
            <!-- 🔥 보험사 선택을 독립 Full Card로 -->
            <div class="card full">
              <div class="cardTitleRow">
                <div class="cardTitle">보험사 선택 (복수 선택 가능)</div>
                <div class="countBadge">
                  선택 {{ totalSelectedCount }}개
                </div>
              </div>
          
              <div class="insurerActions">
                <button class="ghostBtn" @click="selectAll">전체 선택</button>
                <button class="ghostBtn" @click="clearAll">전체 해제</button>
              </div>
              
              <div class="insurerSection">

                <div class="sectionHeader" @click="toggleDamage">
                  <span>
                    손해보험
                    <small class="subCount">
                      ({{ damageSelectedCount }}개 선택)
                    </small>
                  </span>
                  <span class="chevron" :class="{ open: damageOpen }"></span>
                </div>
              
                <transition name="accordion">
                  <div v-show="damageOpen" class="sectionBody">
                    <div class="insurer-grid">
                      <label
                        v-for="i in damageInsurers"
                        :key="i.code"
                        class="checkItem"
                      >
                        <input
                          type="checkbox"
                          :value="i.code"
                          v-model="selectedInsurers"
                        />
                        {{ i.name }}
                      </label>
                    </div>
                  </div>
                </transition>
              
              </div>
              
              <div class="insurerSection">

                <div class="sectionHeader" @click="toggleLife">
                  <span>
                    생명보험
                    <small class="subCount">
                      ({{ lifeSelectedCount }}개 선택)
                    </small>
                  </span>
                  <span class="chevron" :class="{ open: lifeOpen }"></span>
                </div>
              
                <transition name="accordion">
                  <div v-show="lifeOpen" class="sectionBody">
                    <div class="insurer-grid">
                      <label
                        v-for="i in lifeInsurers"
                        :key="i.code"
                        class="checkItem"
                      >
                        <input
                          type="checkbox"
                          :value="i.code"
                          v-model="selectedInsurers"
                        />
                        {{ i.name }}
                      </label>
                    </div>
                  </div>
                </transition>
              
              </div>
              <!-- 🔵 선택 보험사 고객센터 / 팩스 정보 -->
              <div class="insurerSection">
              
                <!-- 헤더 (접기/펼치기 + 개수 표시) -->
                <div
                  class="sectionHeader contactHeader"
                  :class="{
                    blueTone: damageSelectedCount > 0 && lifeSelectedCount === 0,
                    purpleTone: lifeSelectedCount > 0 && damageSelectedCount === 0,
                    mixedTone: damageSelectedCount > 0 && lifeSelectedCount > 0
                  }"
                  @click="contactOpen = !contactOpen"
                >
                  <span>
                    고객센터 / 팩스
                    <small class="subCount">
                      ({{ totalSelectedCount }}개)
                    </small>
                  </span>
                  <span class="chevron" :class="{ open: contactOpen }"></span>
                </div>
              
                <transition name="accordion">
                  <div v-show="contactOpen" class="sectionBody">
                    <!-- 🔵 선택이 없을 때 -->
                    <div
                      v-if="selectedInsurerDetails.length === 0"
                      class="emptyState"
                    >
                      <div class="emptyText">
                        아직 선택된 보험사가 없습니다.
                      </div>
                      <div class="emptySub">
                        보험사를 선택하면 고객센터 및 보험금 청구 팩스 정보가 표시됩니다.
                      </div>
                    </div>
                    <!-- 🔵 카드뷰 형태 -->
                    <div class="contactCardGrid">
                      <div
                        v-for="ins in selectedInsurerDetails"
                        :key="ins.code"
                        class="contactCard"
                      >
                        <div class="contactCardTitle">
                          {{ ins.name }}
                        </div>
              
                        <div class="contactRow">
                          <span>📞 고객센터</span>
                          <a
                            v-if="ins.ars"
                            :href="'tel:' + ins.ars"
                            class="telLink"
                          >
                            {{ ins.ars }}
                          </a>
                          <span v-else>정보 없음</span>
                        </div>
              
                        <div class="contactRow">
                          <span>📠 보험금 청구팩스</span>
                          <span>
                            {{ ins.fax ? ins.fax : "고객센터 발급 요청" }}
                          </span>
                        </div>
                      </div>
                    </div>
              
                  </div>
                </transition>
              
              </div>
            </div>
            
            <!-- 기본정보 -->
            <div class="card">
              <div class="cardTitle">기본정보</div>
              
              <!-- 청구인 이름 -->
              <div class="labelRow">
                <label class="label">청구인(피보험자) 이름</label>
              
                <label class="label label--inline">
                  <input type="checkbox" v-model="form.의료급여수급권자" />
                  의료급여수급권자
                </label>
              </div>
              <input v-model="form.청구인" class="input" placeholder="예: 홍길동" />
            
              <!-- 주민번호 -->
              <div class="row2">
                <div>
                  <label class="label">주민번호 앞 6자리</label>
                  <input
                    ref="frontRef"
                    v-model="form.주민앞"
                    class="input"
                    maxlength="6"
                    inputmode="numeric"
                    pattern="[0-9]*"
                    placeholder="900101"
                    @input="handleFrontInput"
                  />
                </div>
              
                <div>
                  <label class="label">주민번호 뒤 7자리</label>
                  <input
                    ref="backRef"
                    v-model="form.주민뒤"
                    class="input"
                    maxlength="7"
                    inputmode="numeric"
                    pattern="[0-9]*"
                    placeholder="1000000"
                    @input="handleBackInput"
                  />
                </div>
              </div>
            
              <!-- 연락처 추가 -->
              <label class="label">연락처 (보험금 청구 연락 받을 휴대폰)</label>
              <input
                v-model="form.연락처"
                class="input"
                placeholder="예: 01012345678"
                @input="formatPhone"
              />
            
              <!-- 수익자 다름 토글 -->
              <div class="beneficiaryToggle">
                <label class="checkItem">
                  <input type="checkbox" v-model="form.수익자다름" />
                  계약자/수익자가 다른 경우입니다
                </label>
              </div>
            
              <!-- 수익자 추가 영역 (조건부 노출) -->
              <transition name="fade">
                <div v-if="form.수익자다름" class="subCard">
                  <label class="label">계약자/수익자 이름</label>
                  <input v-model="form.수익자이름" class="input" />
            
                  <div class="row2">
                    <div>
                      <label class="label">주민번호 앞 6자리</label>
                      <input
                        ref="benefFrontRef"
                        v-model="form.수익자주민앞"
                        class="input"
                        maxlength="6"
                        inputmode="numeric"
                        pattern="[0-9]*"
                        placeholder="900101"
                        @input="handleBenefFrontInput"
                      />
                    </div>
                  
                    <div>
                      <label class="label">주민번호 뒤 7자리</label>
                      <input
                        ref="benefBackRef"
                        v-model="form.수익자주민뒤"
                        class="input"
                        maxlength="7"
                        inputmode="numeric"
                        pattern="[0-9]*"
                        placeholder="1000000"
                        @input="handleBenefBackInput"
                      />
                    </div>
                  </div>
                  <div class="miniHint">
                    * 청구서의 수익자 부분에 표시됨 
                  </div>
                </div>
              </transition>
            </div>

            <!-- 사고정보 -->
            <div class="card">
              <div class="cardTitle">사고정보</div>

              <label class="label">사고 유형</label>
              <div class="seg">
                <button
                  type="button"
                  class="segBtn"
                  :class="{ active: form.사고유형 === '질병' }"
                  @click="form.사고유형 = '질병'"
                >
                  질병
                </button>
                <button
                  type="button"
                  class="segBtn"
                  :class="{ active: form.사고유형 === '일반상해' }"
                  @click="form.사고유형 = '일반상해'"
                >
                  일반상해
                </button>
                <button
                  type="button"
                  class="segBtn"
                  :class="{ active: form.사고유형 === '교통사고' }"
                  @click="form.사고유형 = '교통사고'"
                >
                  교통사고
                </button>
              </div>

              <label class="label">사고일자(진료일자)</label>
              <input v-model="form.사고일자" class="input" type="date" />

              <label class="label">사고(내원) 경위 / 질병 내용</label>
              <textarea
                v-model="form.사고내용"
                class="textarea"
                rows="5"
                placeholder="예) 감기 몸살 / 골절 / 염좌 / 절단 / 상처 등"
              ></textarea>

              <div
                v-if="form.사고유형 !== '질병'"
                class="field"
              >
                <label class="field-label">
                  사고(상해) 발생 주소 <span class="optional">(선택)</span>
                </label>
                <input
                  class="field-input"
                  v-model="form.사고주소"
                  placeholder="예: 서울 영등포구 ..."
                />
              </div>
            </div>

            <!-- 계좌 -->
            <div class="card">
              <div class="sectionHeaderRow">
                <div class="cardTitle">보험금 지급 계좌</div>
              
                <label class="inlineCheck">
                  <div class="beneficiaryToggle">
                    <label class="checkItem">
                      <input type="checkbox" v-model="form.자동이체동일" />
                      자동이체 계좌 동일
                    </label>
                  </div>
                </label>
              </div>

              <label class="label">은행</label>
              <input v-model="form.은행" class="input" placeholder="예: 신한은행" :disabled="form.자동이체동일"/>

              <label class="label">계좌번호</label>
              <input
                v-model="form.계좌"
                class="input"
                placeholder="숫자만 입력"
                :disabled="form.자동이체동일"
                inputmode="numeric"
                @input="handleAccountInput"
              />
              <label class="label">예금주</label>
              <input v-model="form.예금주" class="input" placeholder="예: 홍길동" :disabled="form.자동이체동일"/>

              <div class="miniHint">
                * 반드시 보험수익자 계좌로 입력해야 실손 청구가 됩니다.
              </div>
            </div>

            <!-- 서명 -->
            <div class="card">
              <div class="cardTitle">본인 자필 서명</div>
            
              <!-- 본인 서명 -->
              <div class="signWrap">
                <canvas ref="canvas"></canvas>
                <button class="clearX" @click="clearSign">✕</button>
              </div>
            
              <div v-if="showSignActions" class="rowActions">
                <button class="btn" @click="clearSign">지우기</button>
                <button class="btnPrimary" @click="saveSign">서명 저장</button>
              </div>
              <!--<div v-if="form.서명_base64" class="saved">서명 저장됨 ✅</div> 
              <div class="miniHint">
                * 자필 서명을 위조하여 등록하는 경우 관련 법률에 의해 법적 처벌을 받을 수 있습니다.
              </div> -->
            
              <!-- 🔥 수익자 서명 (같은 카드 안에 추가) -->
              <transition name="fade">
                <div v-if="form.수익자다름" class="beneficiaryBlock">
                  <div class="beneficiaryTitle">수익자 자필 서명</div>
            
                  <div class="signWrap">
                    <canvas ref="beneficiaryCanvas"></canvas>
                    <button class="clearX" @click="clearBeneficiarySign">✕</button>
                  </div>
            
                  <div v-if="showSignActions"  class="rowActions">
                    <button class="btn" @click="clearBeneficiarySign">지우기</button>
                  </div>
                </div>
              </transition>
            </div>
            <!-- 청구서류 업로드 -->
            <!-- ===== 드롭존 ===== -->
            <div class="card full">

              <div class="cardTitle">
                청구서류 업로드
              </div>

              <div
                class="dropzone"
                :class="{ over: isOver }"
                @dragenter.prevent="onDragEnter"
                @dragover.prevent="onDragOver"
                @dragleave.prevent="onDragLeave"
                @drop.prevent="onDrop"
                @click="openDzPicker"
                role="button"
                tabindex="0"
              >
                <div class="dz-icon">📎</div>
              
                <div class="dz-title">
                  청구서에 붙일 진단서 / 영수증 / 처방전 등을 업로드하세요
                </div>
              
                <div class="dz-hint">
                  여러 파일 업로드 가능 (PDF / 이미지)
                </div>
              
                <!-- 미니 픽커 -->
                <div v-if="dzPickerOpen" class="dz-picker">
                  <button class="dz-pick-btn" @click.stop="pickFromDz('pdf')">
                    📄 PDF 선택
                  </button>
              
                  <button class="dz-pick-btn" @click.stop="pickFromDz('images')">
                    🖼 이미지 선택
                  </button>
              
                  <button class="dz-pick-cancel" @click.stop="closeDzPicker">
                    취소
                  </button>
                </div>
              
                <div
                  v-if="dzPickerOpen"
                  class="dz-picker-mask"
                  @click="closeDzPicker"
                />
              
                <!-- 숨김 input -->
              
                <input
                  ref="fileInputPdf"
                  type="file"
                  multiple
                  style="display:none"
                  @change="onPicked"
                  accept="application/pdf"
                />
              
                <input
                  ref="fileInputImages"
                  type="file"
                  multiple
                  style="display:none"
                  @change="onPicked"
                  accept="image/*"
                />
                
              </div>
              <div class="miniHint">
                  * 청구서류 업로드는 선택사항입니다.
              </div>
              <!-- ===== 파일 리스트 ===== -->
              
              <div v-if="uploadedFiles.length" class="sheet-files">

                <div
                  v-for="(item, index) in uploadedFiles"
                  :key="index"
                  class="sheet-file"
                >
              
                  <!-- 썸네일 / 아이콘 -->
                  <div class="file-kind">
              
                    <img
                      v-if="item.file && item.file.type.startsWith('image/')"
                      :src="item.preview"
                      class="file-thumb"
                    />
              
                    <span v-else class="file-icon">
                      {{ resolveEmoji(item.file.name) }}
                    </span>
              
                  </div>
              
              
                  <!-- 파일 정보 -->
                  <div class="file-info">
              
                    <div class="file-name">
                      {{ item.file.name }}
                    </div>
              
                    <div class="file-size">
                      {{ (item.file.size / 1024 / 1024).toFixed(2) }} MB
                    </div>
              
                    <!-- 이미지일 때만 -->
                    <div
                      v-if="item.file.type.startsWith('image/')"
                      class="scan-option"
                    >
                      <label class="scan-toggle">
                        <input
                          type="checkbox"
                          v-model="item.scan"
                        />
                        <span class="scan-label">팩스 최적화</span>
                      </label>
                    </div>
              
                  </div>
              
              
                  <!-- 삭제 -->
                  <button
                    class="file-remove"
                    @click="removeFile(index)"
                    title="파일 삭제"
                  >
                    🗑
                  </button>
              
                </div>
                <div class="mergeSelector">
                  
                  <div
                    class="mergeCard"
                    :class="{ active: mergeMode === 'separate' }"
                    @click="mergeMode='separate'"
                  >
                    <div class="mergeIcon">📄</div>
                
                    <div class="mergeText">
                      <div class="mergeTitle">
                        PDF 따로 생성 <span class="badge">출력용</span>
                      </div>
                      <div class="mergeDesc">
                        청구서와 첨부서류를 각각 생성합니다
                      </div>
                    </div>
                
                  </div>

                  <div
                    class="mergeCard"
                    :class="{ active: mergeMode === 'merge' }"
                    @click="mergeMode='merge'"
                  >
                    <div class="mergeIcon">📎</div>
                
                    <div class="mergeText">
                      <div class="mergeTitle">
                        하나의 PDF로 합치기 <span class="badgeMobile">모바일용</span>
                      </div>
                      <div class="mergeDesc">
                        청구서와 청구서류를 하나의 파일로 생성합니다
                      </div>
                    </div>
                
                  </div>
                
                
                  
                
                </div>
              
              </div>
               
            </div>
          </div>
          <!-- Bottom Actions -->
          <div class="footerBar">
            <div class="securityNote">
              ※ 생성된 PDF 1페이지 상단에 해당 보험사의 고객센터 및 보험금 청구 팩스번호가 자동 표시됩니다.
            </div>
            <div class="cta">
              <button class="btnPrimary big" :disabled="loading" @click="renderPdf">
                <span v-if="!loading">PDF 생성</span>
                <span v-else>생성 중... {{ elapsedSeconds }}초</span>
              </button>
            
              <div v-if="downloadFiles.length" class="download-area">
            
                <!-- 개별 다운로드 -->
                <a
                  v-for="f in sortedDownloadFiles"
                  :key="f.insurer"
                  :class="getDownloadClass(f.insurer)"
                  :href="API_BASE + f.download_url"
                  download
                  target="_blank"
                >
                  {{ getDownloadLabel(f.insurer) }}
                </a>
            
                <!-- 🔥 2개 이상일 때 전체 다운로드 -->
                <a
                  v-if="downloadFiles.length > 1"
                  class="btnAll big"
                  :href="allDownloadUrl"
                  download
                  target="_blank"
                >
                  전체 다운로드
                </a>
            
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
  <transition name="glass-toast">
    <div v-if="showToast" class="glass-toast">
      <div class="glass-inner">
        <span class="glass-icon">✓</span>
        <span class="glass-text">{{ toastMessage }}</span>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { onMounted, onBeforeUnmount, ref, watch, nextTick , computed, reactive} from "vue";

const frontRef = ref(null)
const backRef = ref(null)
const benefFrontRef = ref(null)
const benefBackRef = ref(null)

const elapsedSeconds = ref(0)

let timer = null

const toastMessage = ref("")
const toastType = ref("success")
const showToast = ref(false)
const showSignActions = ref(false)

const showSample = ref(false)

const uploadedFiles = ref([])

const isOver = ref(false)
const dzPickerOpen = ref(false)

const fileInputPdf = ref(null)
const fileInputImages = ref(null)

const mergeMode = ref("separate") 

// 페이지 수만큼 배열
const samplePages = [1, 2, 3] 

const API_BASE = "https://claim.throw.im";
//const API_BASE = "";

const form = reactive({
  청구인: "",
  주민앞: "",
  주민뒤: "",
  주소1: "",
  주소2: "",
  직업: "직장인",
  사고유형: "질병",
  사고일자: "",
  사고내용: "",
  사고주소: "",
  은행: "",
  계좌: "",
  예금주: "",
  서명_base64: "",
  수익자서명_base64: "",
  연락처: "",
  수익자다름: false,
  수익자이름: "",
  수익자주민앞: "",
  수익자주민뒤: "",
  의료급여수급권자: false, // ✅ 추가
  자동이체동일: false,
});
/*
const insurers = [
  // 손해보험
  { code: "meritz", name: "메리츠화재", group: "damage" },
  { code: "kb_s", name: "KB손해보험", group: "damage" },
  { code: "db_s", name: "DB손해보험", group: "damage" },
  { code: "samsung_s", name: "삼성화재", group: "damage" },
  { code: "hyundai", name: "현대해상", group: "damage" },
  { code: "hanwha_s", name: "한화손해보험", group: "damage" },
  { code: "heungkuk_s", name: "흥국화재", group: "damage" },
  { code: "lotte", name: "롯데손해보험", group: "damage" },
  { code: "nh_s", name: "농협손해보험", group: "damage" },
  { code: "yebo", name: "예별손해보험", group: "damage" },
  { code: "lina_s", name: "라이나손보", group: "damage" },
  { code: "hana_s", name: "하나손보", group: "damage" },
  { code: "aig_s", name: "AIG손보", group: "damage" },
  { code: "axa", name: "AXA손보", group: "damage" },
  { code: "post", name: "우체국", group: "damage" },

  // 생명보험
  { code: "samsung_l", name: "삼성생명", group: "life" },
  { code: "hanwha_l", name: "한화생명", group: "life" },
  { code: "shinhan_l", name: "신한라이프", group: "life" },
  { code: "dongyang", name: "동양생명", group: "life" },
  { code: "lina_l", name: "라이나생명", group: "life" },
  { code: "mirae", name: "미래에셋", group: "life" },
  { code: "metlife", name: "메트라이프", group: "life" },
  { code: "kyobo", name: "교보생명", group: "life" },
  { code: "db_l", name: "DB생명", group: "life" },
  { code: "aia", name: "AIA생명", group: "life" },
  { code: "chubb", name: "처브라이프", group: "life" },
  { code: "nh_l", name: "농협생명", group: "life" },
  { code: "abl", name: "ABL생명", group: "life" },
  { code: "bnp", name: "BNP파리바", group: "life" },
  { code: "kdb", name: "KDB생명", group: "life" },
  { code: "imlife", name: "IM라이프", group: "life" },
  { code: "kb_l", name: "KB라이프", group: "life" },
  { code: "hana_l", name: "하나생명", group: "life" },
  { code: "fubon", name: "푸본현대", group: "life" },
  { code: "heungkuk_l", name: "흥국생명", group: "life" }
];
*/
const insurers = [
  // =========================
  // 손해보험
  // =========================
  { code: "meritz", name: "메리츠화재", group: "damage", ars: "1566-7711", fax: "0505-021-3400" },
  { code: "kb_s", name: "KB손해보험", group: "damage", ars: "1544-0114", fax: "0505-136-6500" },
  { code: "db_s", name: "DB손해보험", group: "damage", ars: "1588-0100", fax: "0505-181-4862" },
  { code: "samsung_s", name: "삼성화재", group: "damage", ars: "1588-5114", fax: "0505-162-0872" },
  { code: "hyundai", name: "현대해상", group: "damage", ars: "1588-5656", fax: "0507-774-6060" },
  { code: "hanwha_s", name: "한화손해보험", group: "damage", ars: "1566-8000", fax: "0502-779-1004" },
  { code: "heungkuk_s", name: "흥국화재", group: "damage", ars: "1688-1688", fax: "0504-800-0700" },
  { code: "lotte", name: "롯데손해보험", group: "damage", ars: "1588-3344", fax: "0507-333-9999" },
  { code: "nh_s", name: "농협손해보험", group: "damage", ars: "1644-9000", fax: "0505-060-7000" },
  { code: "yebo", name: "예별손해보험", group: "damage", ars: "1588-5959", fax: "0505-088-1646" },
  { code: "lina_s", name: "라이나손보", group: "damage", ars: "1566-5800", fax: "02-6742-3992" },
  { code: "hana_s", name: "하나손보", group: "damage", ars: "1566-3000", fax: "0504-3764-0765" },
  { code: "aig_s", name: "AIG손보", group: "damage", ars: "1544-2792", fax: "02-2011-4607" },
  { code: "axa", name: "AXA손보", group: "damage", ars: "1566-1566", fax: null },
  { code: "post", name: "우체국", group: "damage", ars: "1599-0100", fax: "0505-005-1224" },

  // =========================
  // 생명보험
  // =========================
  { code: "samsung_l", name: "삼성생명", group: "life", ars: "1588-3114", fax: "02-3709-5591" },
  { code: "hanwha_l", name: "한화생명", group: "life", ars: "1588-6363", fax: null },
  { code: "shinhan_l", name: "신한라이프", group: "life", ars: "1588-5580", fax: null },
  { code: "dongyang", name: "동양생명", group: "life", ars: "1577-1004", fax: "02-3289-4517" },
  { code: "lina_l", name: "라이나생명", group: "life", ars: "1588-0058", fax: "02-6944-1200" },
  { code: "mirae", name: "미래에셋", group: "life", ars: "1588-0220", fax: null },
  { code: "metlife", name: "메트라이프", group: "life", ars: "1588-9600", fax: null },
  { code: "kyobo", name: "교보생명", group: "life", ars: "1588-1001", fax: null },
  { code: "db_l", name: "DB생명", group: "life", ars: "1588-3131", fax: "0505-129-3134" },
  { code: "aia", name: "AIA생명", group: "life", ars: "1588-9898", fax: "02-2021-4540" },
  { code: "chubb", name: "처브라이프", group: "life", ars: "1599-4600", fax: "02-3480-7801" },
  { code: "nh_l", name: "농협생명", group: "life", ars: "1544-4000", fax: "02-6971-6040" },
  { code: "abl", name: "ABL생명", group: "life", ars: "1588-6500", fax: "02-3299-5544" },
  { code: "bnp", name: "BNP파리바", group: "life", ars: "1688-1118", fax: null },
  { code: "kdb", name: "KDB생명", group: "life", ars: "1588-4040", fax: "02-2669-6500" },
  { code: "imlife", name: "IM라이프", group: "life", ars: "1588-4770", fax: "0505-083-5420" },
  { code: "kb_l", name: "KB라이프", group: "life", ars: "1588-3374", fax: "02-390-4629" },
  { code: "hana_l", name: "하나생명", group: "life", ars: "1577-1112", fax: null },
  { code: "fubon", name: "푸본현대", group: "life", ars: "1577-3311", fax: "0505-106-0311" },
  { code: "heungkuk_l", name: "흥국생명", group: "life", ars: "1588-2288", fax: null }
];

function onDragEnter() {
  isOver.value = true
}

function onDragOver() {
  isOver.value = true
}

function onDragLeave() {
  isOver.value = false
}

function onDrop(e) {

  isOver.value = false

  const files = Array.from(e.dataTransfer.files)

  const filtered = files.filter(file => {
    return file.type === "application/pdf" ||
           file.type.startsWith("image/")
  })

  filtered.forEach(file => {

    uploadedFiles.value.push({
      file: file,
      scan: file.type.startsWith("image/"),
      preview: file.type.startsWith("image/")
        ? URL.createObjectURL(file)
        : null
    })
  
  })
}

function openDzPicker() {
  dzPickerOpen.value = true
}

function closeDzPicker() {
  dzPickerOpen.value = false
}

function pickFromDz(type) {

  if (type === "pdf") {
    fileInputPdf.value?.click()
  }

  if (type === "images") {
    fileInputImages.value?.click()
  }
}

function onPicked(e) {

  const files = Array.from(e.target.files)

  const filtered = files.filter(file => {
    return file.type === "application/pdf" ||
           file.type.startsWith("image/")
  })

  filtered.forEach(file => {
  
    uploadedFiles.value.push({
      file: file,
      scan: file.type.startsWith("image/"),
      preview: file.type.startsWith("image/")
        ? URL.createObjectURL(file)
        : null
    })
  
  })

  dzPickerOpen.value = false

  e.target.value = null
}

function removeFile(index) {

  const item = uploadedFiles.value[index]

  if (item.preview) {
    URL.revokeObjectURL(item.preview)
  }

  uploadedFiles.value.splice(index, 1)
}

function resolveEmoji(name){

  const ext = name.split('.').pop().toLowerCase()

  if(ext === "pdf") return "📄"

  if(["jpg","jpeg","png","gif","webp"].includes(ext))
    return "🖼"

  return "📎"
}

function startTimer() {

  elapsedSeconds.value = 0

  timer = setInterval(() => {
    elapsedSeconds.value++
  }, 1000)

}

function stopTimer() {

  if (timer) {
    clearInterval(timer)
    timer = null
  }

}

const damageInsurers = computed(() =>
  insurers.filter(i => i.group === "damage")
);

const lifeInsurers = computed(() =>
  insurers.filter(i => i.group === "life")
);

// 선택된 보험사 상세 객체 목록
const selectedInsurerDetails = computed(() => {
  return insurers.filter(i =>
    selectedInsurers.value.includes(i.code)
  )
})


const contactOpen = ref(false)

const damageOpen = ref(false); // 기본 닫힘
const lifeOpen = ref(false);   // 기본 닫힘

const allDownloadUrl = computed(() => {
  return API_BASE + "/api/download/all"
})

function getDownloadLabel(code){

  if(code === "docs"){
    return "보험금청구서류 PDF 다운로드"
  }

  const found = insurers.find(i => i.code === code)
  return `${found ? found.name : code} PDF 다운로드`

}

function getDownloadClass(code){

  if(code === "docs"){
    return "btnDocs big"
  }

  return "btnSuccess big"

}

function handleFrontInput(e) {
  // 숫자만 남기기
  let value = e.target.value.replace(/[^0-9]/g, '')
  value = value.slice(0, 6)

  form.주민앞 = value

  // 6자리 되면 자동 포커스 이동
  if (value.length === 6) {
    backRef.value?.focus()
  }
}

function handleBackInput(e) {
  let value = e.target.value.replace(/[^0-9]/g, '')
  value = value.slice(0, 7)

  form.주민뒤 = value
}

function handleBenefFrontInput(e) {
  let value = e.target.value.replace(/[^0-9]/g, '')
  value = value.slice(0, 6)

  form.수익자주민앞 = value

  if (value.length === 6) {
    benefBackRef.value?.focus()
  }
}

function handleBenefBackInput(e) {
  let value = e.target.value.replace(/[^0-9]/g, '')
  value = value.slice(0, 7)

  form.수익자주민뒤 = value
}

function formatPhone(e) {
  let value = e.target.value.replace(/[^0-9]/g, '')

  if (value.length <= 3) {
    form.연락처 = value
  }
  else if (value.length <= 7) {
    form.연락처 = value.replace(/(\d{3})(\d+)/, '$1-$2')
  }
  else if (value.length <= 10) {
    form.연락처 = value.replace(/(\d{3})(\d{3})(\d+)/, '$1-$2-$3')
  }
  else {
    form.연락처 = value.replace(/(\d{3})(\d{4})(\d+)/, '$1-$2-$3')
  }
}

function showSuccess(message) {
  toastMessage.value = message
  showToast.value = true

  setTimeout(() => {
    showToast.value = false
  }, 2000)
}

function showError(message) {
  toastType.value = "error"
  toastMessage.value = message
  showToast.value = true

  setTimeout(() => {
    showToast.value = false
  }, 2500)
}

function handleAccountInput(e) {
  // 숫자 + 하이픈만 허용
  let value = e.target.value.replace(/[^0-9-]/g, '')

  // 하이픈이 연속으로 입력되는 것 방지
  value = value.replace(/--+/g, '-')

  // 맨 앞에 하이픈 못오게
  if (value.startsWith('-')) {
    value = value.substring(1)
  }

  form.계좌 = value
}

function toggleDamage(){
  damageOpen.value = !damageOpen.value;
}

function toggleLife(){
  lifeOpen.value = !lifeOpen.value;
}

// 전체 선택
function selectAll(){
  selectedInsurers.value = insurers.map(i => i.code);

  // 🔥 둘 다 열기
  damageOpen.value = true;
  lifeOpen.value = true;
}

// 전체 해제
function clearAll(){
  selectedInsurers.value = [];

  // 🔥 둘 다 닫기
  damageOpen.value = false;
  lifeOpen.value = false;
}

// 전체 선택 개수
const totalSelectedCount = computed(() => 
  selectedInsurers.value.length
);

// 손해보험 선택 개수
const damageSelectedCount = computed(() =>
  damageInsurers.value.filter(i => 
    selectedInsurers.value.includes(i.code)
  ).length
);

// 생명보험 선택 개수
const lifeSelectedCount = computed(() =>
  lifeInsurers.value.filter(i => 
    selectedInsurers.value.includes(i.code)
  ).length
);

const selectedInsurers = ref([]);
const loading = ref(false);
const downloadFiles = ref([]);

const sortedDownloadFiles = computed(() => {

  const docs = downloadFiles.value.filter(f => f.insurer === "docs")
  const insurers = downloadFiles.value.filter(f => f.insurer !== "docs")

  return [...docs, ...insurers]

})


// 체크 시 자동 복사
watch(
  () => form.자동이체동일,
  (val) => {
    if (val) {
      form.은행 = "";
      form.계좌 = "";
      form.예금주 = "";
    }
  }
);

watch(
  () => selectedInsurers.value.length,
  (newLength) => {
    if (newLength > 0) {
      contactOpen.value = true
    } else {
      contactOpen.value = false
    }
  }
)

onBeforeUnmount(() => {

  uploadedFiles.value.forEach(item => {
    if (item.preview) {
      URL.revokeObjectURL(item.preview)
    }
  })

})

const beneficiaryCanvas = ref(null)
let beneficiaryCtx = null

const canvas = ref(null)
let ctx = null

onMounted(() => {

  // 🔥 모바일이면 기본 merge 모드
  const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)

  if(isMobile){
    mergeMode.value = "merge"
  }

  const setupCanvas = (el, setCtx) => {
    const rect = el.getBoundingClientRect()
    const dpr = window.devicePixelRatio || 1

    el.width = rect.width * dpr
    el.height = rect.height * dpr

    const context = el.getContext('2d')
    context.scale(dpr, dpr)
    context.lineCap = 'round'
    context.lineJoin = 'round'
    context.lineWidth = 5

    const getPos = (e) => {
      const r = el.getBoundingClientRect()
      const clientX = e.touches ? e.touches[0].clientX : e.clientX
      const clientY = e.touches ? e.touches[0].clientY : e.clientY
      return {
        x: clientX - r.left,
        y: clientY - r.top
      }
    }

    let drawing = false

    const start = (e) => {
      drawing = true
      const { x, y } = getPos(e)
      context.beginPath()
      context.moveTo(x, y)
    }

    const move = (e) => {
      if (!drawing) return
      e.preventDefault()
      const { x, y } = getPos(e)
      context.lineTo(x, y)
      context.stroke()
    }

    const end = () => {
      drawing = false
      context.closePath()
    }

    el.addEventListener("mousedown", start)
    el.addEventListener("mousemove", move)
    window.addEventListener("mouseup", end)

    el.addEventListener("touchstart", start, { passive: false })
    el.addEventListener("touchmove", move, { passive: false })
    window.addEventListener("touchend", end)

    setCtx(context)
  }

  // 본인 서명 초기화
  if (canvas.value) {
    setupCanvas(canvas.value, (c) => ctx = c)
  }

});

watch(() => form.수익자다름, async (val) => {
  if (!val) return

  await nextTick()

  if (!beneficiaryCanvas.value) return

  const el = beneficiaryCanvas.value
  const rect = el.getBoundingClientRect()
  const dpr = window.devicePixelRatio || 1

  el.width = rect.width * dpr
  el.height = rect.height * dpr

  beneficiaryCtx = el.getContext('2d')
  beneficiaryCtx.scale(dpr, dpr)
  beneficiaryCtx.lineCap = 'round'
  beneficiaryCtx.lineJoin = 'round'
  beneficiaryCtx.lineWidth = 5

  let drawing = false

  const getPos = (e) => {
    const r = el.getBoundingClientRect()
    const clientX = e.touches ? e.touches[0].clientX : e.clientX
    const clientY = e.touches ? e.touches[0].clientY : e.clientY
    return {
      x: clientX - r.left,
      y: clientY - r.top
    }
  }

  const start = (e) => {
    drawing = true
    const { x, y } = getPos(e)
    beneficiaryCtx.beginPath()
    beneficiaryCtx.moveTo(x, y)
  }

  const move = (e) => {
    if (!drawing) return
    e.preventDefault()
    const { x, y } = getPos(e)
    beneficiaryCtx.lineTo(x, y)
    beneficiaryCtx.stroke()
  }

  const end = () => {
    drawing = false
    beneficiaryCtx.closePath()
  }

  el.addEventListener("mousedown", start)
  el.addEventListener("mousemove", move)
  window.addEventListener("mouseup", end)

  el.addEventListener("touchstart", start, { passive: false })
  el.addEventListener("touchmove", move, { passive: false })
  window.addEventListener("touchend", end)
});

function clearBeneficiarySign() {
  beneficiaryCtx?.clearRect(
    0,
    0,
    beneficiaryCanvas.value.width,
    beneficiaryCanvas.value.height
  )
  form.수익자서명_base64 = ""
}

function clearSign() {
  ctx?.clearRect(0, 0, canvas.value.width, canvas.value.height);
  form.서명_base64 = "";
}

function saveSign() {
  form.서명_base64 = canvas.value.toDataURL("image/png");
}

async function renderPdf() {

  if (selectedInsurerDetails.value.length === 0) {
    showError("보험사를 먼저 선택해주세요.");
    return;
  }

  if (canvas.value) {
    form.서명_base64 = canvas.value.toDataURL("image/png");
  }

  if (form.수익자다름 && beneficiaryCanvas.value) {
    form.수익자서명_base64 =
      beneficiaryCanvas.value.toDataURL("image/png");
  }

  loading.value = true;
  downloadFiles.value = [];
  startTimer();   // ⭐ 추가

  try {

    const formData = new FormData();

    // 기존 JSON 데이터
    formData.append(
      "data",
      JSON.stringify({
        insurer_codes: selectedInsurers.value,
        data: form
      })
    );

    // 🔥 업로드 파일 추가
    uploadedFiles.value.forEach((item,i)=>{

      formData.append("files", item.file)
      formData.append("scan_"+i, item.scan)
      
    })
    
    formData.append("merge_mode", mergeMode.value)

    const res = await fetch("/api/render", {
      method: "POST",
      body: formData
    });
    
    if(uploadedFiles.value.length && mergeMode.value==="merge"){
      console.log("서류 병합 모드")
    }

    const text = await res.text();

    let json;
    try {
      json = JSON.parse(text);
    } catch (e) {
      console.error("서버 응답:", text);
      throw new Error("서버가 JSON이 아닌 응답을 반환했습니다.");
    }

    if (!json.ok) throw new Error(json.error || "생성 실패");

    downloadFiles.value = json.files;

    showSuccess("PDF 생성이 완료되었습니다.");

  } catch (e) {
    showError(e.message);
  } finally {
    loading.value = false;
    stopTimer();    // ⭐ 추가
  }
}
</script>

<style>
/* ===== Page background (THROW 느낌) ===== */
.page{
  min-height: 100vh;
  background:
    radial-gradient(1200px 600px at 50% -10%, rgba(255,255,255,.9), rgba(255,255,255,0)),
    linear-gradient(180deg, #eaf2ff 0%, #f6fbff 55%, #ffffff 100%);
  color:#111827;
}

.brand{ display:flex; align-items:center; gap:10px; }

.nav{ display:flex; gap:26px; align-items:center; }
.navLink{
  text-decoration:none;
  color:#111827;
  opacity:.75;
  font-weight:600;
}
.navLink:hover{ opacity:1; }
.topRight{ display:flex; align-items:center; gap:14px; }
.iconBtn{
  width:38px;height:38px;border-radius:999px;
  border:1px solid rgba(17,24,39,.12);
  background: rgba(255,255,255,.55);
  cursor:pointer;
}
.login{
  text-decoration:none;
  color:#111827;
  font-weight:700;
  opacity:.8;
}
.login:hover{ opacity:1; }

/* ===== Hero ===== */
.hero{
  position:relative;
  padding:48px 5px 64px;
}
.heroInner{
  max-width: 1400px;
  margin: 0 auto;
  text-align:center;
}

.subtitle{
  margin:0 auto 12px;
  max-width: 720px;
  color:#374151;
  line-height:1.55;
  font-size:16px;
}

/* ===== Main Panel ===== */
.panel{
  text-align:left;
  max-width: 1020px;
  margin: 0 auto;
  background: rgba(255,255,255,.75);
  border: 1px solid rgba(17,24,39,.08);
  border-radius: 18px;
  overflow:hidden;
}

.insurerBox{
  min-width: 240px;
}
.label{
  display:block;
  font-size:12px;
  color:#6b7280;
  margin:10px 0 6px;
}

/* ===== Form grid ===== */
.grid{
  display:grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  padding: 0px 0px 10px;
}
.card{
  background: rgba(255,255,255,.8);
  border: 1px solid rgba(17,24,39,.08);
  border-radius: 16px;
  padding: 10px;
  overflow: hidden;
}
.cardTitle{
  font-weight:800;
  margin-bottom:8px;
  letter-spacing:-0.3px;
}

/* Inputs */
.input, .select, .textarea{
  width:100%;
  border-radius: 12px;
  border: 1px solid rgba(17,24,39,.12);
  box-sizing: border-box;
  padding: 12px 12px;
  outline:none;
  background: rgba(255,255,255,.92);
  transition: .15s ease;
}
.textarea{ resize: vertical; min-height: 120px; }
.input:focus, .select:focus, .textarea:focus{
  border-color: rgba(37,99,235,.55);
}

input[type="date"]{
  height:48px;
  width:100%;
  box-sizing:border-box;
  padding:12px;
  -webkit-appearance:none;
  appearance:none;
  background:white;
}

/* Rows */
.row2{
  display:grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

/* Chips */
.chips{ display:flex; flex-wrap:wrap; gap:8px; margin-top:6px; }
.chip{
  border-radius: 999px;
  padding: 8px 12px;
  border: 1px solid rgba(17,24,39,.12);
  background: rgba(255,255,255,.75);
  cursor:pointer;
  font-weight:700;
  font-size:12px;
  color:#374151;
}
.chip.active{
  background: rgba(37,99,235,.10);
  border-color: rgba(37,99,235,.35);
  color:#1d4ed8;
}

/* Segmented */
.seg{
  display:flex;
  gap:10px;
  margin-bottom:6px;
}
.segBtn{
  flex:1;
  border-radius: 999px;
  padding: 10px 12px;
  border: 1px solid rgba(17,24,39,.12);
  background: rgba(255,255,255,.75);
  cursor:pointer;
  font-weight:800;
  color:#374151;
}
.segBtn.active{
  background:#2563eb;
  border-color:#2563eb;
  color:#fff;
}

/* Signature */
.signWrap{
  position:relative;
  border-radius: 16px;
  overflow:hidden;
  border: 1px solid rgba(17,24,39,.12);
  background: #fff;
}
canvas{
  width:100%;
  display:block;
}
.clearX{
  position:absolute;
  right:10px;
  top:10px;
  width:34px;
  height:34px;
  border-radius:999px;
  border:1px solid rgba(17,24,39,.14);
  background: rgba(255,255,255,.8);
  cursor:pointer;
}
.rowActions{
  display:none;
  gap:10px;
  margin-top:10px;
}
.btn{
  padding:10px 12px;
  border-radius: 12px;
  border: 1px solid rgba(17,24,39,.12);
  background: rgba(255,255,255,.75);
  cursor:pointer;
  font-weight:800;
}
.btnPrimary{
  padding:10px 12px;
  border-radius: 12px;
  border:none;
  background:#0b4ddb;
  color:#fff;
  cursor:pointer;
  font-weight:900;
}
.btnPrimary:hover{ filter: brightness(1.02); }
.btnPrimary:disabled{ opacity:.6; cursor:not-allowed; }
.saved{ margin-top:8px; color:#059669; font-weight:800; font-size:13px; }

.miniHint{
  margin-top:10px;
  color:#6b7280;
  font-size:12px;
  line-height:1.35;
}

/* Footer bar */
.footerBar{
  display:flex;
  align-items:center;
  justify-content:space-between;
  padding: 14px 16px 18px;
  border-top: 1px solid rgba(17,24,39,.06);
  background: rgba(255,255,255,.55);
  gap: 12px;
}
.securityNote{
  color:#6b7280;
  font-size:12px;
}
.cta{
  display:flex;
  gap:10px;
  align-items:center;
  justify-content:flex-end;
  flex-wrap: wrap;
}
.big{ padding: 12px 16px; border-radius: 14px; }
.btnSuccess,
.btnAll {
  display:inline-flex;
  align-items:center;
  justify-content:center;
  padding:12px 16px;       /* ✅ big 기준 동일 */
  border-radius:14px;      /* ✅ big 기준 동일 */
  font-weight:900;         /* ✅ btnPrimary 동일 */
  font-size:14px;
  min-height:30;         /* 🔥 높이 고정 (권장) */
  border:none;
  cursor:pointer;
}

/* 개별 다운로드 */
.btnSuccess{
  background:#10b981;
  color:#fff;
  text-decoration:none;
}

/* 전체 다운로드 */
.btnAll{
  background:#2f6df6;
  color:#fff;
  text-decoration:none;
}
.btnSuccess:hover{ filter: brightness(1.02); }
.insurerList{
  display:flex;
  flex-wrap:wrap;
  gap:12px;
}

.checkItem{
  display:flex;
  align-items:center;
  gap:6px;
  font-size:14px;
  font-weight:700;
}

.card.full {
  grid-column: 1 / -1;
}

.input, .select, .textarea {
  width: 100%;
  max-width: 100%;
}

.beneficiaryToggle{
  margin-top: 14px;
  padding: 10px 12px;
  border-radius: 12px;
  background: rgba(37,99,235,.05);
  border: 1px solid rgba(37,99,235,.15);
}

.subCard{
  margin-top: 12px;
  padding: 14px;
  border-radius: 14px;
  background: rgba(17,24,39,.03);
  border: 1px dashed rgba(17,24,39,.15);
}

.subTitle{
  font-weight:800;
  margin-bottom:8px;
  color:#374151;
}

.fade-enter-active,
.fade-leave-active {
  transition: all .2s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity:0;
  transform: translateY(-6px);
}

.beneficiaryBlock{
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px dashed rgba(17,24,39,.12);
}

.beneficiaryTitle{
  font-weight:800;
  margin-bottom:8px;
  color:#374151;
}
.signWrap{
  height:120px;     /* 기존 140px였다면 반으로 */
}

.field {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 16px;
}

.field-label {
  font-size: 13px;
  font-weight: 500;
  color: #6b7280;
}

.optional {
  color: #9ca3af;
  font-weight: 400;
}

.field-input {
  height: 48px;
  border-radius: 14px;
  border: 1px solid #e5e7eb;
  padding: 0 16px;
  font-size: 14px;
}

.insurer-grid{
  display:grid;
  grid-template-columns: repeat(3, 1fr);
  gap:12px;
  margin-bottom:20px;
}

.groupTitle{
  margin:20px 0 10px;
  font-size:14px;
  font-weight:600;
  color:#374151;
}

.insurerActions{
  display:flex;
  gap:10px;
  margin-bottom:15px;
}

.ghostBtn{
  background:#f3f4f6;
  border:1px solid #e5e7eb;
  padding:6px 12px;
  border-radius:8px;
  cursor:pointer;
}

.groupTitle{
  margin:20px 0 10px;
  font-weight:600;
  display:flex;
  justify-content:space-between;
  align-items:center;
}

.clickable{
  cursor:pointer;
}

.arrow{
  font-size:12px;
  color:#6b7280;
}

.fade-enter-active,
.fade-leave-active{
  transition: all 0.2s ease;
}

.fade-enter-from,
.fade-leave-to{
  opacity:0;
  transform: translateY(-5px);
}

.insurerSection{
  border:1px solid #e5e7eb;
  border-radius:12px;
  margin-bottom:16px;
  overflow:hidden;
  background:#fafafa;
}

.sectionHeader{
  display:flex;
  justify-content:space-between;
  align-items:center;
  padding:14px 18px;
  font-weight:600;
  cursor:pointer;
  background:#f3f4f6;
  border-radius:12px;
}

.sectionBody{
  padding:16px;
  background:white;
}

.chevron{
  width:10px;
  height:10px;
  border-right:2px solid #6b7280;
  border-bottom:2px solid #6b7280;
  transform: rotate(45deg);
  transition:0.2s;
}

.chevron.open{
  transform: rotate(-135deg);
}

.accordion-enter-active,
.accordion-leave-active{
  transition: all 0.2s ease;
}

.accordion-enter-from,
.accordion-leave-to{
  opacity:0;
  transform: translateY(-5px);
}

.cardTitleRow{
  display:flex;
  justify-content:space-between;
  align-items:center;
  margin-bottom:10px;
}

.countBadge{
  background:#2563eb;
  color:white;
  font-size:12px;
  padding:4px 10px;
  border-radius:20px;
}

.subCount{
  font-size:12px;
  color:#6b7280;
  margin-left:6px;
}

.input:disabled{
  background:#f3f4f6;
  color:#9ca3af;
  cursor:not-allowed;
  border-color:#e5e7eb;
}

.labelRow{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:12px;
}

.checkItem--inline{
  display:flex;
  align-items:center;
  gap:8px;
  white-space:nowrap;
  flex:0 0 auto;
}

.checkItem--inline input{
  width:18px;
  height:18px;
  accent-color:#2563eb;
}

.labelRow{
  display:flex;
  align-items:center;          /* ✅ 세로 중앙 */
  justify-content:space-between;
}

/* 오른쪽 체크 영역 */
.label--inline{
  display:flex;
  align-items:center;          /* ✅ 체크박스 + 텍스트 중앙 */
  gap:8px;
  flex:0 0 auto;
  line-height:1;               /* ✅ baseline 영향 제거 */
}

/* 체크박스 */
.label--inline input{
  width:14px;
  height:14px;
  margin:0;                    /* ✅ 기본 여백 제거 */
  position:relative;
  top:-1px;                    /* 🔥 미세 보정 (필요하면 -2px까지) */
}
.download-area {
  display: flex;
  flex-wrap: wrap;          /* 🔥 줄바꿈 허용 */
  gap: 14px;
  justify-content: center;  /* 가운데 정렬 */
  margin-top: 20px;
}

.btnSuccess,
.btnAll {
  flex: 0 0 auto;           /* 줄어들지 않게 */
  min-width: 160px;
  text-align: center;
}

/* ===============================
   Glass Toast - Blue/Navy Final
   =============================== */

.glass-toast {
  position: fixed;
  top: 60px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 998;
}

/* 캡슐 본체 */
.glass-inner {
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 32px;
  border-radius: 999px;

  /* 🔥 최종 사용 블루-네이비 그라데이션 */
  background: linear-gradient(
    135deg,
    rgba(37, 99, 235, 0.45),
    rgba(17, 24, 139, 0.35)
  );

  border: 1px solid rgba(255, 255, 255, 0.35);

  color: #ffffff;
  font-weight: 600;
  font-size: 15px;
  letter-spacing: -0.2px;
}

/* 아이콘 */
.glass-icon {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: linear-gradient(135deg, #2563eb, #111889);

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 14px;
  color: white;

}

/* 하이라이트 (유리 느낌 핵심) */
.glass-inner::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 999px;
  background: linear-gradient(
    135deg,
    rgba(255,255,255,0.65),
    rgba(255,255,255,0.05)
  );
  opacity: 0.35;
  pointer-events: none;
}

/* 애니메이션 */
.glass-toast-enter-active,
.glass-toast-leave-active {
  transition: all 0.4s ease;
}

.glass-toast-enter-from {
  opacity: 0;
  transform: translate(-50%, -25px) scale(0.95);
}

.glass-toast-leave-to {
  opacity: 0;
  transform: translate(-50%, -25px) scale(0.95);
}

.admin-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 18px;
  border-radius: 30px;
  border: none;
  cursor: pointer;
  font-weight: 600;
  background: linear-gradient(135deg, #4f8cff, #2563eb);
  color: white;
  transition: all 0.25s ease;
}

.admin-btn:hover {
  transform: translateY(-2px);
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 997;
}

.modal-box {
  width: 320px;
  background: white;
  border-radius: 14px;
  padding: 28px;
  text-align: center;
  animation: fadeUp 0.25s ease;
}

.modal-actions {
  display: flex;
  justify-content: space-between;
  margin-top: 18px;
}

.cancel-btn {
  flex: 1;
  margin-right: 6px;
  padding: 8px;
  border-radius: 8px;
  border: 1px solid #ddd;
  background: white;
  cursor: pointer;
}

.confirm-btn {
  flex: 1;
  margin-left: 6px;
  padding: 8px;
  border-radius: 8px;
  border: none;
  background: #2563eb;
  color: white;
  cursor: pointer;
}

.error-msg {
  margin-top: 12px;
  font-size: 13px;
  color: red;
}

@keyframes fadeUp {
  from { transform: translateY(10px); opacity: 0 }
  to { transform: translateY(0); opacity: 1 }
}

.header-actions {
  display: flex;
  gap: 12px;
}

.feedback-btn {
  padding: 9px 18px;
  border-radius: 30px;
  border: 1.5px solid #2563eb;
  background: white;
  color: #2563eb;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.25s ease;
}

.feedback-btn:hover {
  background: #2563eb;
  color: white;
}

.admin-btn {
  padding: 9px 18px;
  border-radius: 30px;
  border: none;
  font-weight: 600;
  cursor: pointer;
  background: linear-gradient(135deg, #4f8cff, #2563eb);
  color: white;
  transition: all 0.25s ease;
}


.contactCardGrid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 16px;
}

.contactCard {
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);

  background: rgba(255, 255, 255, 0.18);
  border: 1px solid rgba(255, 255, 255, 0.3);

  border-radius: 18px;
  padding: 20px;

  transition: all 0.25s ease;
}

.contactAccordion {
  background: linear-gradient(
    135deg,
    #e0f2fe,
    #f1f5f9
  );
  padding: 18px;
  border-radius: 20px;
}

.contactCardTitle {
  font-weight: 700;
  font-size: 16px;
  margin-bottom: 14px;
  color: #1e293b;
}

.contactRow {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  padding: 4px 0;
}

.contactCard:hover {
  transform: translateY(-4px);
}

.contactCardTitle {
  font-weight: 700;
  margin-bottom: 12px;
  font-size: 15px;
}

.contactRow {
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
  font-size: 14px;
}

.telLink {
  color: #2563eb;
  text-decoration: none;
}

.telLink:hover {
  text-decoration: underline;
}

.sampleArea {
  margin: 20px 0 30px;
  text-align: center;
}

.pdfModal {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.pdfBox {
  width: min(900px, 95vw);
  height: 92vh;
  background: white;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.pdfScrollArea {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  background: #f3f4f6;
}

.sampleImg {
  width: 100%;
  height: auto;
  display: block;
  margin-bottom: 16px;
  border-radius: 8px;
}
.closeBtn {
  position: absolute;
  top: 10px;
  right: 15px;
  z-index: 10;   /* 👈 이거 추가 */
  background: white;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  font-size: 18px;
  border: none;
  cursor: pointer;
}

.pdfFooter {
  padding: 16px;
  border-top: 1px solid #e5e7eb;
  background: #f9fafb;
}

.closeFullBtn {
  width: 100%;
  padding: 14px 0;
  border-radius: 12px;
  border: none;
  background: #2563eb;
  color: white;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s ease;
}

.closeFullBtn:hover {
  background: #1e40af;
}

/* ===== Hero Summary Block ===== */
.heroSummary {
  grid-column: 1 / -1;

  display: grid;
  grid-template-columns: 1fr auto;   /* 왼쪽 텍스트 / 오른쪽 버튼 */
  align-items: center;
  margin: 0px 16px;
  padding: 10px 32px;
  border-radius: 32px;

  background: rgba(255,255,255,0.92);
  border: 1px solid rgba(37,99,235,0.15);

  position: relative;
  z-index: 20;     /* 🔥 구름 위 */
}

.heroText {
  max-width: 620px;
}

.heroBadge {
  display: inline-block;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1px;
  color: #2563eb;
  background: rgba(37, 99, 235, 0.1);
  padding: 6px 12px;
  border-radius: 999px;
  margin-bottom: 16px;
}

.heroDesc {
  font-size: 15px;
  color: #374151;
  line-height: 1.6;
}

.heroAction {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

/* 샘플 버튼 고급화 */
.btnSample {
  padding: 14px 26px;
  border-radius: 14px;
  border: none;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;

  background: linear-gradient(
    135deg,
    #22c55e,
    #15803d
  );
  

  color: white;


  transition: all 0.25s ease;
}

.btnSample:hover {
  transform: translateY(-3px);
}

.sheet-files {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.sheet-file {
  display: flex;
  align-items: center;
  gap: 14px;

  padding: 14px;
  border-radius: 12px;

  background: white;
  border: 1px solid #e5e7eb;

  transition: all 0.2s ease;
}

.sheet-file:hover {
  border-color: #d1d5db;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
}

.file-kind {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.file-thumb {
  width: 48px;
  height: 48px;
  object-fit: cover;
  border-radius: 6px;
}

.file-icon {
  font-size: 28px;
}

.file-info {
  flex: 1;
}

.file-name {
  font-weight: 600;
  font-size: 14px;
}

.file-size {
  font-size: 12px;
  color: #6b7280;
  margin-top: 2px;
}

/* 스캔 옵션 */

.scan-option {
  margin-top: 6px;
}

.scan-toggle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #16a34a;
}

.scan-label {
  background: #ecfdf5;
  padding: 2px 8px;
  border-radius: 6px;
}

/* 삭제 버튼 */

.file-remove {
  border: none;
  background: none;
  font-size: 18px;
  cursor: pointer;
  color: #9ca3af;
  padding: 6px;
}

.file-remove:hover {
  color: #ef4444;
}

@media (max-width: 768px){
  .heroSummary {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .heroAction {
    justify-content: flex-start;
  }

  .btnSample {
    width: 100%;
  }
}

.flowRow{
  display:flex;
  justify-content:space-between;
  align-items:center;
  gap:16px;
}

.flowText{
  margin:0 auto 12px;
  max-width: 720px;
  color:#374151;
  line-height:1.55;
  font-size:14px;
}

.btnSample{
  flex:0 0 auto;        /* 🔥 버튼이 눌려서 작아지지 않게 */
}

.container {
  text-align:left;
  max-width: 1020px;
  margin: 5px auto 20px; 
  padding:24px 10px 24px;
  background: rgba(255,255,255,.75);
  border: 1px solid rgba(17,24,39,.08);
  border-radius: 18px;
  overflow:hidden;
}

.file-thumb{
  width:40px;
  height:40px;
  object-fit:cover;
  border-radius:6px;
}

.mergeSelector{
  margin-top:16px;
  display:flex;
  flex-direction:column;
  gap:10px;
}

.mergeCard{
  display:flex;
  align-items:center;
  gap:14px;

  padding:14px 16px;
  border-radius:14px;

  border:1px solid #e5e7eb;
  background:white;

  cursor:pointer;
  transition: all .2s ease;
}

.mergeCard:hover{
  border-color:#2563eb;
  transform: translateY(-1px);
}

.mergeCard.active{
  border:2px solid #2563eb;
  background: rgba(37,99,235,.06);
}

.mergeIcon{
  font-size:22px;
}

.mergeTitle{
  font-weight:700;
  font-size:14px;
}

.mergeDesc{
  font-size:12px;
  color:#6b7280;
  margin-top:2px;
}

.badge{
  background:#2563eb;
  color:white;
  font-size:11px;
  padding:2px 6px;
  border-radius:6px;
  margin-left:6px;
}

.badgeMobile{
  background:#ef4444;
  color:white;
  font-size:11px;
  padding:2px 6px;
  border-radius:6px;
  margin-left:6px;
}

/* 첨부서류 다운로드 버튼 */

.btnDocs{
  display:inline-flex;
  align-items:center;
  justify-content:center;

  padding:12px 16px;
  border-radius:14px;

  background:#f59e0b;
  color:white;
  font-weight:900;
  text-decoration:none;
}

.btnDocs:hover{
  filter:brightness(1.05);
}

/* Responsive */

html {
  box-sizing: border-box;
}
*, *::before, *::after {
  box-sizing: inherit;
}
@media (max-width: 980px){
  .grid{ grid-template-columns: 1fr; }
  .insurerBox{ width:100%; }
  .footerBar{ flex-direction: column; align-items:flex-start; }
  .cta{ width:100%; justify-content:flex-start; }
  .flowRow{
    flex-direction:column;      /* 세로로 변경 */
    align-items:flex-start;     /* 왼쪽 정렬 */
    gap:14px;
  }

  .flowText{
    width:100%;
    word-break: keep-all;       /* 한글 단어 유지 */
  }

  .btnSample{
    width:100%;                 /* 버튼 전체폭 */
    text-align:center;
  }
}
</style>